<template>
  <div>
    <div class="case-top-line">
      <div class="case-top-line-left">
        <div class="case-name">Dalekovod d.d.</div>
      </div>
    </div>
    <div class="case-predmet crm-profile">
      <div class="case-predmet-left">
        <div class="crm-info section">
            <div class="section-title">Info</div>
            <div class="edit-info add-button add-pen"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"/></g></g></svg></div>
            <div class="crm-info-part">
              <div class="case-info-item">
                <div class="case-info-item-title">OIB</div>
                <div class="case-info-item-info">47911242222</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Broj telefona</div>
                <div class="case-info-item-info">099 223 7742</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Adresa</div>
                <div class="case-info-item-info">Marijana Čavića 4, 10 000 Zagreb, Hrvatska</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Adresa 2</div>
                <div class="case-info-item-info">Dalekovod d.o.o. Mostar - Ante Starčevića b.b., 88 000 Mostar</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Adresa 3</div>
                <div class="case-info-item-info">Dalekovod Inženjering in trgovina d.o.o. Ljubljana - Zavetiška 1, 1000 Ljubljana, Slovenia</div>
              </div>
            </div>
            <div class="crm-info-part">
              <div class="case-info-item">
                <div class="case-info-item-title">e-mail</div>
                <div class="case-info-item-info">dalekovod@dalekovod.hr</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">e-mail 2</div>
                <div class="case-info-item-info">uprava - Martina Lončarić Levanić: martina.loncaric@dalekovod.hr</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">e-mail 3</div>
                <div class="case-info-item-info">administracija: administracija@dalekovod.hr
                </div>
              </div>
              <div class="case-info-item">
                  <div class="case-info-item-title">Telefon</div>
                  <div class="case-info-item-info">centrala:  +385 1 24 11 111</div>
              </div>
              <div class="case-info-item">
                  <div class="case-info-item-title">Telefon 2</div>
                  <div class="case-info-item-info">uprava - Martina Lončarić Levanić:  +385 1 2459 700</div>
              </div>
              <div class="case-info-item">
                  <div class="case-info-item-title">Web stranica</div>
                  <div class="case-info-item-info">Hrvatska - http://www.dalekovod.com</div>
              </div>
              <div class="case-info-item">
                  <div class="case-info-item-title">Web stranica 2</div>
                  <div class="case-info-item-info">Slovenija - http://www.dalekovod.si</div>
              </div>
            </div>
            <div class="crm-info-part">
              <div class="case-info-item">
                <div class="case-info-item-title">Industrija</div>
                <div class="case-info-item-info">Inženjering, proizvodnja i izgradnja</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Godišnji prihod</div>
                <div class="case-info-item-info">1.252,2 milijuna kuna</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Izvod iz sud.reg.</div>
                <div class="case-info-item-info">dalekovod-sudski-reg.pdf </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Izvješće iz Posl. Hrv.</div>
                <div class="case-info-item-info">dalekovod-poslovna.pdf </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Insolv-Info izvješće</div>
                <div class="case-info-item-info">dalekovod-insolvinfo.pdf </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Izvod iz JRR-a</div>
                <div class="case-info-item-info">dalekovod-jrr.pdf</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Br. Predmeta:</div>
              <div class="case-info-item-info">preporuka od klijenta: Infrastruktura d.o.o</div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Br. Predmeta:</div>
              <div class="case-info-item-info">
                <span>facebook https://www.facebook.com/dalekovod/</span>
                <span>linkedin https://hr.linkedin.com/company/dalekovod-d-d-</span>
              </div>
            </div>
        </div>
        <div class="crm-komunikacija section">
          <div class="section-title">Komunikacija</div>
          <div class="add-zadatak add-button add-plus"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#0acab1" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"/></g></g></svg></div>
          <div class="case-info-item">
            <div class="case-info-item-title">24.03.2021.</div>
            <div class="case-info-item-info">
              Poslan prijedlog ugovora o zastupanju u predmetnom sporu Dalekovod protiv Elevio AB – trenutni status – faza pregovaranja
              <span class="komunikacija-autor">Dmitar T.</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Problem sa Elevio AB.18.3.2021. Sent from: Igor Viduka</a></div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">18.03.2021.</div>
            <div class="case-info-item-info">
              Klijent traži sastanak vezan uz spor sa norveškim kooperantom 
              <span class="komunikacija-autor">Marko Porobija</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Potpis ugovora u poslovnoj suradnji 11.03.2021. Sent from: Martina Lončarić...</a></div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">12.03.2021.</div>
            <div class="case-info-item-info">
              Ugovor o poslovnoj suradnji odobren, finaliziran i potpisan. Ugovor unesen u ERP.
              <span class="komunikacija-autor">Dubravka Črnila</span>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">07.03.2021.</div>
            <div class="case-info-item-info">
              Predugovor odobren, finaliziran i potpisan, Dalekovod oformljen kao klijent, slijedi izrada ugovora u poslovnoj suradnji
              <span class="komunikacija-autor">Dubravka Črnila</span>
              <div class="komunikacija-zadatak">unesen zadatak</div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">02.03.2021.</div>
            <div class="case-info-item-info">
              Dalekovod je kontaktiran i uspostavljen je kontakt sa članicom uprave Martinom Lončarić Levanić, poslati prijedlog predugovora o uspostavi poslovne suradnje
              <span class="komunikacija-autor">Suzana Cesarec</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Problem sa Elevio AB.18.3.2021. Sent from: Igor Viduka</a></div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">02.03.2021.</div>
            <div class="case-info-item-info">
              Dalekovod kao potencijalni klijent preporučen od strane Infrastruktura d.o.o. (gospođa Cindrić) – vezano uz spor oko izgradnje dalekovoda u Norveškoj 
              <span class="komunikacija-autor">Suzana Cesarec</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Možda novi klijent za vas? 30.01.2021. Sent from: Ivana Cindrić</a></div>
            </div>
          </div>
        </div><!-- Close crm-komunikacija  -->
      </div><!-- Close case-predmet-left -->
      <div class="case-predmet-right">
        <div class="case-predmet-right-leftpt">
          <div class="crm-opis section">
            <div class="section-title">Opis</div>
            <p>Dalekovod d.d. je moderna organizacija koja pruža usluge inženjeringa, proizvodnje i izgradnje. </p>
            <p>Tvrtka je specijalizirana za izvođenje ugovora po sistemu "ključ u ruke" u slijedećim područjima:</p>
            <ul>
              <li>elektroenergetskih objekata, posebice dalekovoda od 0,4 do 1000 kV</li>
              <li>transformatorskih stanica svih tipova i naponskih nivoa do 500 kV</li>
              <li>zračnih, podzemnih i podvodnih kabela do 110 kV</li>
              <li>telekomunikacijskih objekata</li>
              <li>svih vrsta mreža i antena</li>
              <li>proizvodnje ovjesne i spojne opreme za sve vrste dalekovoda i transformatorskih stanica od 0,4 do 1000 kV</li>
              <li>izrade i ugradnje svih metalnih dijelova za prometnice, a posebice za: cestovnu rasvjetu, zaštitne ograde i signalizaciju u prometu</li>
              <li>rasvjete tunela i upravljanja prometom</li>
              <li>elektrifikacije željezničkih pruga i tramvaja u gradovima</li> 
            </ul>
          </div>
          <div class="crm-naplata section">
            <div class="section-title">Naplata:</div>
            <div class="edit-info add-button add-pen"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"/></g></g></svg></div>
            <div class="case-info-item">
              <div class="case-info-item-title">Vrsta naplate</div>
              <div class="case-info-item-info">Miješano</div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Predmet</div>
              <div class="case-info-item-info"><a href="#">Dalekovod protiv Elevio AB </a><div class="naplata-button">po ugovoru<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12"><g><g><path fill="#717184" d="M7.82 8.407a.448.448 0 0 1-.324-.139l-3.14-3.293a.45.45 0 0 1 .323-.759h1.646V.773a.75.75 0 0 1 .748-.748h1.495a.75.75 0 0 1 .748.748v3.443h1.646a.45.45 0 0 1 .324.76L8.145 8.267a.448.448 0 0 1-.325.14zM13.953 12H1.688c-.577 0-1.047-.47-1.047-1.048v-.3c0-.577.47-1.047 1.047-1.047h12.265c.577 0 1.047.47 1.047 1.048v.3C15 11.53 14.53 12 13.953 12z"/></g></g></svg></div></div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Predmet</div>
              <div class="case-info-item-info"><a href="#">Sigfox protiv Dalekovoda </a><div class="naplata-button">po ugovoru<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12"><g><g><path fill="#717184" d="M7.82 8.407a.448.448 0 0 1-.324-.139l-3.14-3.293a.45.45 0 0 1 .323-.759h1.646V.773a.75.75 0 0 1 .748-.748h1.495a.75.75 0 0 1 .748.748v3.443h1.646a.45.45 0 0 1 .324.76L8.145 8.267a.448.448 0 0 1-.325.14zM13.953 12H1.688c-.577 0-1.047-.47-1.047-1.048v-.3c0-.577.47-1.047 1.047-1.047h12.265c.577 0 1.047.47 1.047 1.048v.3C15 11.53 14.53 12 13.953 12z"/></g></g></svg></div></div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Predmet</div>
              <div class="case-info-item-info"><a href="#">Dalekovod protiv Grad Zagreb </a><div class="naplata-button">po tarifi</div></div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Predmet</div>
              <div class="case-info-item-info"><a href="#">Dalekovod protiv Ivo Ivić </a><div class="naplata-button">po tarifi</div></div>
            </div>
          </div>
        </div><!-- Close case-predmet-right-leftpt -->
        <div class="case-predmet-right-rightpt">
          <div class="case-team section">
            <div class="section-title">Vezane osobe</div>
            <div class="edit-case-team add-button add-pen"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"/></g></g></svg></div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member1"></div>
              <div class="case-team-member-txt">Marko Marković<span class="role">Zadužen</span></div>
            </div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member2"></div>
              <div class="case-team-member-txt">Maja Kauzler - Geček<span class="role">Upisan od</span></div>
            </div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-team-member-txt">Dmitar Tar<span class="role">Predstavnik uprave</span></div>
            </div>
          </div>
          <div class="crmprofile-ugovori">
            <div class="section-title ugovori-title">Ugovori</div>
            <div class="crmprofile-ugovor section">
              <div class="ugovor-icon"><img class="ugovor-icon-pdf" src="@/assets/img/pdf_icon.svg" /></div>
              <div class="ugovor-info ugovor-info-draft">
                <div class="inside-folder-title">
                  Predugovor o uspostavi poslove suradnje.pdf
                  <span class="draft"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g><g><path fill="#fd4087" d="M10.613 10.98a.59.59 0 0 1-.59.59c-.782-.033-.782-1.148 0-1.18a.59.59 0 0 1 .59.59zm9.434-6.256c-.165 4.484-2.335 15.472-10.023 15.37C2.35 20.207.16 9.21 0 4.723c1.932.002 3.67.133 5.49-.73C7.389 3.198 8.652 1.596 10.024.12l1.646 1.78c1.616 1.763 3.897 2.83 6.27 2.823zm-4.36 6.256c-3.331-5.466-7.98-5.49-11.326 0 3.169 5.244 7.741 5.584 11.142.303zm-5.663-2.954c2.015 0 3.702 2.145 4.267 2.954-2.76 3.9-5.767 3.911-8.535-.001 1.077-1.594 2.842-3.007 4.268-2.953zm1.77 2.954c-.098-2.346-3.443-2.347-3.54 0 0 .975.794 1.768 1.77 1.768.975 0 1.77-.793 1.77-1.768z"/></g></g></svg></span>
                </div>
                <div class="detalji-spisa-tiny">
                  <span class="tezina">10,9mb</span>
                </div>
                <div class="ugovor-faza">odobren/finaliziran</div>
              </div>
            </div>
            <div class="crmprofile-ugovor section">
              <div class="ugovor-icon"><img class="ugovor-icon-pdf" src="@/assets/img/pdf_icon.svg" /></div>
              <div class="ugovor-info">
                <div class="inside-folder-title">
                  Ugovor o poslovnoj suradnji.pdf
                </div>
                <div class="detalji-spisa-tiny">
                  <span class="tezina">10,9mb</span>
                </div>
                <div class="ugovor-faza">odobren/finaliziran</div>
              </div>
            </div>
            <div class="crmprofile-ugovor section">
              <div class="ugovor-icon"><img class="ugovor-icon-pdf" src="@/assets/img/pdf_icon.svg" /></div>
              <div class="ugovor-info">
                <div class="inside-folder-title">
                 Ugovor o zastupanju u predmetnoj sporu Dal...
                </div>
                <div class="detalji-spisa-tiny">
                  <span class="tezina">10,9mb</span>
                </div>
                <div class="ugovor-faza">faza pregovaranja</div>
              </div>
            </div>
            <div class="crmprofile-ugovor section">
              <div class="ugovor-icon"><img class="ugovor-icon-pdf" src="@/assets/img/pdf_icon.svg" /></div>
              <div class="ugovor-info">
                <div class="inside-folder-title">
                  Ugovor o zastupanju u predmetnom sporu....
                </div>
                <div class="detalji-spisa-tiny">
                  <span class="tezina">10,9mb</span>
                </div>
                <div class="ugovor-faza">potrebno obnavljanje/ aneks ugovora</div>
              </div>
            </div>
          </div>
          <div class="crmprofil-organizacija section">
            <div class="section-title zadaci-title">Organizacija prodaje usluga<span class="zadaci-amount">19</span></div>
            <div class="organizacija-subtitle">planiranje prodaje</div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Detaljnije informacije o pozivu i pozadini tvrtke</div>
              <div class="organizacija-checkbox active-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Istražite što potencijalni klijent želi postići.</div>
              <div class="organizacija-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Navedite potencijalne kontakte koji će biti uključeni u proces donošenja odluka.</div>
              <div class="organizacija-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Inicirajte kontakt: 'prodajte sastanak'.</div>
              <div class="organizacija-checkbox active-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-subtitle">planiranje prodaje</div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Potražite dodatne informacije poput članaka u trgovinskim časopisima.</div>
              <div class="organizacija-checkbox active-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Nazovite referalni izvor da se zahvalite i dobijete informacije o "potencijalnom klijentu".</div>
              <div class="organizacija-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="organizacija-item zadatak">
              <div class="organizacija-txt">Koristite dodatne "mrežne" kontakte i druge odnose.</div>
              <div class="organizacija-checkbox"><img src="@/assets/img/tick.svg"/></div>
            </div>
            <div class="zadaci-svi pogledaj-sve">pogledaj sve</div>
          </div>
        </div><!-- Close case-predmet-right-rightpt -->
      </div><!-- Close case-predmet-right -->
    </div><!-- Close case-predmet -->
    
  </div>
</template>

<script>
import auth from "@/services/auth";
import share from "@/apiCallers/promise_handler_db/sharepoint";
import Spisi from "@/components/caseComponents/Spisi.vue";
import person from "@/apiCallers/promise_handler_db/person"

export default {
  components: {
    Spisi
  },
  data() {
    return {
      selectedTab: "Opis",
      accessToken: "",
      group: {},
      owners: [],
      members: [],
      goranDocuments: [],
      files: [],
    };
  },
  mounted() {
    setTimeout(this.openWordClient, 3500);
     
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    // console.log(this.accessToken)
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        this.getGroupById();
      }
    },
  },
  methods: {
    getGroupById() {
      // console.log(this.$route.params.uid)
      share
        .getById(this.accessToken, this.$route.params.uid)
        .then((response) => {
          this.group = response.data.groupDetail;
          this.owners = response.data.owners.value;
          this.members = response.data.members.value;
          this.goranDocuments = response.data.goranDocuments.value;
          this.files = response.data.files.value;
          console.log(response.data);
        });

      person
        .getMembers(this.accessToken, this.$route.params.uid)
        .then((response) => {
          this.members = response.data.value;
          this.isLoaded = true;
        });
    },
    openWordClient() {
      var word_open = document.getElementById("openword");
      var word_link = "ms-word:ofe|u|" + this.goranDocuments[0].webUrl;
      word_open.onclick = function () {
        window.location.href = word_link;
        return false;
      };
    },
  },
};
</script>


<style>
</style>